// employees/JobContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getJobListApi, createJobApi, updateJobApi, getJobListPublicApi} from "api/services/jobs"
import { useSearchParams } from 'react-router-dom';
import useJobFilter from "../hooks/filterHook"
import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"
import { useDispatch } from 'react-redux';
import { handleToast } from 'store/slice/common';
import {  toast, Bounce } from 'react-toastify';
import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";

// Create the Employee context
const JobContext = createContext();

// Custom hook for accessing Employee context easily
export const useJob = () => {
  return useContext(JobContext);
};

// EmployeeProvider component to wrap around components needing access to employee data
export const EmployeeProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch()
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });


    const navigate = useNavigate()

  // Employee state (could be an array of employees, single employee, etc.)
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
  const [selectedJob, setSelectedJob] = useState({});

  const [jobModal, setJobModal] = useState(false);

  const [jobList, setJobData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list")
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useJobFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params
        
})

const setEmployeeParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}


// handleInputChange = (value, key)=>{
//     setPageSettings({
//         ...pageSettings,
//         page: 1,
//         filters
//       })
//       handleSearchInput(value, key))
// }


    const getJobList = () => {
        setLoading(true)
        setFilterLoading(true)

        // let _filters = [...filters].filter(item=> item.value)
        // const filter_params = _filters.reduce((acc, item) => {
        //     acc[item.key] = item.value;
        //     return acc;
        //   }, {});
        let filter_params = getFilterParams()

        // if(filter_params?.employment_date_after){
        //     filter_params.employment_date_after = format(new Date(filter_params.employment_date_after), "yyyy-MM-dd")
        // }
        // if(filter_params?.employment_date_before){
        //     filter_params.employment_date_before = format(new Date(filter_params.employment_date_before), "yyyy-MM-dd")
        // }


          
        getJobListApi({
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          ...filter_params
    
        }).then(response=>{
          console.log(response.data.results)
          setJobData(response.data.results);
          setPageSettings({
            ...pageSettings,
            total: response.data.count
          })
    
          setLoading(false)
          setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    getJobList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  useEffect(()=>{
    setEmployeeParams(pageSettings)
  },[pageSettings])

  const handleApplyFilter = () => {
    // setFilterLoading(true)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })
    // getJobList()


  }

  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData)
  };

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }


  const handleJobDetailPage = (id, index) => {
    navigate(`/company-directory/${id}`)
    setSelectedPage(index)
  }


  const createJobHandler = (data,setError, modalRef, reset) => {
    setLoading(true)
    
    if(selectedJob?.id ){
      updateJobApi(data, selectedJob?.id) 
      .then(response=>{
        console.log(response.data)
        setLoading(false)
        setJobModal(false)
        getJobList()
        toast.success('Job post created successfully!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
        reset()
      
    }).catch(err=>{
        setLoading(false)
        console.log(err, "LLLLLLLL")


          let errors = err.response.data
          for (const [key, value] of Object.entries(errors)) {
            console.log(`${key}: ${value}`);
            setError(key, { type: "custom", message: value })


            // errors[key].forEach(item=>{
            //     setError(key, item)
            // })

          }

    })
    }else{
      createJobApi(data)
      .then(response=>{
        console.log(response.data)
        setLoading(false)
        setJobModal(false)
        getJobList()
        dispatch(handleToast({
          showToast: true,
          toastTitle: "Success",
          toastHeading: "Job Created",
          toastSubheading: "Job Created successfully",
          toastType: "success"
        }))
        reset()
      
    }).catch(err=>{
        setLoading(false)
        console.log(err, "LLLLLLLL")


          let errors = err.response.data
          for (const [key, value] of Object.entries(errors)) {
            console.log(`${key}: ${value}`);
            setError(key, { type: "custom", message: value })


            // errors[key].forEach(item=>{
            //     setError(key, item)
            // })

          }

    })
    }
    


  }

  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    jobList, setJobData,
    loading, setLoading,
    jobList, setJobData,
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    jobModal, setJobModal,
    selectedJob, setSelectedJob,

    handleChange,
    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleJobDetailPage,
    handleDateChange,
    createJobHandler,
    
  }), [jobList , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, jobModal, selectedJob]);

  return (
    <JobContext.Provider value={value}>
      {children}
    </JobContext.Provider>
  );
};